import { useContext, useMemo } from 'react'

import { isArray, isFunction } from 'lodash'

import { GlobalContext } from '../../../../Providers/GlobalProvider'
import EntitiesSelector from '../EntitiesSelector'
import { isObject } from '../../../../utils'
import { InstitutionModalContext } from '../../../../Providers/Forms/InstitutionModal/InstitutionModal'

const InstitutionsSelector = ({ className = '', disabled, dropdownRender, institutions = [], multiple = 'default', placeholder = '', style = {}, values, onChange }) => {
  const gc = useContext(GlobalContext)
  const modalContext = useContext(InstitutionModalContext)

  const institutionEntities = useMemo(() => {
    let institutionEntities = []

    if (isObject(gc) && (!isArray(institutions) || institutions.length === 0)) {
      institutionEntities = gc.institutions
    } else if (isArray(institutions)) {
      institutionEntities = institutions
    }

    return institutionEntities
  }, [institutions, gc])

  const institutionsOptions = useMemo(() => institutionEntities.map(institution => ({
    label: institution.acronym ?? institution.name,
    value: institution.id,
    tooltip: institution.name,
    entity: institution
  })), [institutionEntities])

  return (
    <EntitiesSelector
      placeholder={placeholder}
      disabled={disabled}
      entityOptions={institutionsOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      dropdownRender={modalContext !== undefined && isFunction(dropdownRender) ? dropdownRender(modalContext.setFormHandler) : undefined}
      onChange={onChange}
    />
  )
}

export default InstitutionsSelector
